<template>
  <div>
    <div class="ir-sub-menu">
      <ul class="col3">
        <li>
          <a href="/ir/stock" class="selected">株式情報</a>
        </li>
        <li>
          <a href="/ir/meeting">株主総会</a>
        </li>
        <li>
          <a href="/ir/stock_quotations">株価情報</a>
        </li>
      </ul>
    </div>
    <section>
      <div class="l-service">
        <div class="l-service-header">
          <h2 class="heading-default heading-default-center">株式情報</h2>
          <h3 class="heading-small heading-small-center heading-small-mt-sp">
            STOCK OVERVIEW
          </h3>

          <div class="l-service-content-inner">
            <table class="table-lists">
              <tbody>
                <tr class="table-lists-item">
                  <th class="table-lists-title">上場市場</th>
                  <td class="table-lists-detail">
                    東京証券取引所 グロース市場
                  </td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">上場日</th>
                  <td class="table-lists-detail">2017年4月18日</td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">証券コード</th>
                  <td class="table-lists-detail">6548</td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">事業年度</th>
                  <td class="table-lists-detail">毎年7月1日から6月30日まで</td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">定時株主総会</th>
                  <td class="table-lists-detail">毎年9月中</td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">株主確定基準日</th>
                  <td class="table-lists-detail">毎年6月30日</td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">剰余金の配当の基準日</th>
                  <td class="table-lists-detail">毎年12月31日、毎年6月30日</td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">株式の売買単位</th>
                  <td class="table-lists-detail">100株</td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">公告掲載方法</th>
                  <td class="table-lists-detail">
                    当社の公告方法は電子公告としております。ただし、事故その他やむを得ない事由によって電子公告による公告をすることができない場合は、日本経済新聞に掲載しております。
                    <br />当社の公告掲載URLは次のとおりであります。
                    <br />
                    <a href="https://about.tabikobo.com/" target="_blank"
                      >https://about.tabikobo.com/</a
                    >
                  </td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">株主名簿管理人</th>
                  <td class="table-lists-detail">三菱UFJ信託銀行株式会社</td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">同事務取扱場所</th>
                  <td class="table-lists-detail">
                    （連絡先）<br />
                    東京都千代田区丸の内一丁目 4 番 5号 <br />
                    三菱UFJ信託銀行株式会社 証券代行部<br />
                    <br />
                    （郵便物送付先）<br />
                    〒137-8081<br />
                    新東京郵便局私書箱第 29 号<br />
                    三菱UFJ信託銀行株式会社 証券代行部<br />
                    電話 0120-232-711（フリーダイヤル）
                  </td>
                </tr>
                <tr class="table-lists-item">
                  <th class="table-lists-title">各種事務手続き</th>
                  <td class="table-lists-detail">
                    詳しくは、こちらのページにてご確認下さい。
                    <br />
                    <a href="https://www.tr.mufg.jp/daikou/" target="_blank"
                      >https://www.tr.mufg.jp/daikou/</a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "株式情報",
      titleTemplate: "株式情報 | 株式について | IR情報 | 株式会社 旅工房",
    };
  },
};
</script>
